import { FootballType } from 'common/dto-types/team-dto';

const FootballTypeCell = ({ value }: { value: number }): JSX.Element => {
    switch (value) {
        case FootballType.Football:
            return <p>Football</p>;
        case FootballType.Beach:
            return <p>Beach</p>;
        case FootballType.Futsal:
            return <p>Futsal</p>;
        case FootballType.ESport:
            return <p>ESport</p>;
        case FootballType.Unknown:
        default:
            return <p>Unknown</p>;
    }
};

export default FootballTypeCell;
